export default __webpack_public_path__ + "static/media/container.080d86cc.png";